var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeverOffMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.04,
    height: 142.867,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 864"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 711",
    transform: "translate(19.737 31.776)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 45",
    cx: 15.504,
    cy: 15.504,
    transform: "translate(6.742)",
    fill: "#040000",
    r: 15.504
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 412",
    fill: "#040000",
    d: "M17.741 27.384h9.176v18.352h-9.176z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 413",
    fill: "#040000",
    d: "M20.227 39.1h4.077v13.436h-4.077z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 414",
    fill: "#040000",
    d: "M16.905 33.782h10.849v2.778H16.905z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 415",
    fill: "#040000",
    d: "M16.905 43.755h10.849v2.778H16.905z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 708"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 193",
    d: "M42.947 72.378s3.017-11.05 1.328-14.887c-1.605-3.649-9.83-9.994-9.83-9.994l-3.994-.474.4 3.457 2.173.137s7.446 5.285 8.681 8.093c1.175 2.669-1.014 13.4-1.014 13.4z",
    fill: "#040000"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 194",
    d: "M1.842 72.378S-1.175 61.328.514 57.491c1.605-3.649 9.83-9.994 9.83-9.994l3.994-.474-.4 3.457-2.173.137s-7.446 5.285-8.681 8.093c-1.175 2.669 1.014 13.4 1.014 13.4z",
    fill: "#040000"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 46",
    cx: 10.077,
    cy: 10.077,
    transform: "translate(12.169 5.427)",
    fill: "#040000",
    stroke: "#fff",
    strokeMiterlimit: 10,
    r: 10.077
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 195",
    d: "M15.64 39.322l-2.155 9.99 5.688 2.067h6.312l5.688-2.067-2.155-9.99z",
    fill: "none",
    stroke: "#040000",
    strokeMiterlimit: 10,
    strokeWidth: 3.524
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 196",
    d: "M20.021 71.665l.911-11.583-.007-9.833h2.539l.007 9.836.932 11.581-2.074 1.378z",
    fill: "#040000"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "2Arrows leverOff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2",
    d: "M19.044 22.022v4.025h43.952v-4.025l18.436 6.5-18.436 6.5v-3.943H19.044v3.943l-18.437-6.5z",
    fill: "#ff3e3e",
    stroke: "#4d4d4d",
    strokeWidth: 0.403
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2-2",
    d: "M30.099 8.559l-2.8 2.894 31.6 30.549 2.8-2.894 8.736 17.49L52.66 48.46l2.741-2.836-31.6-30.548-2.741 2.835L12.324.422z",
    fill: "#3086ff",
    stroke: "#4d4d4d",
    strokeWidth: 0.403
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2-3",
    d: "M49.266 94.957h-4.025v33.417h4.025l-6.5 14.016-6.5-14.016h3.943V94.959h-3.943l6.5-14.016z",
    fill: "#00b050",
    stroke: "#4d4d4d",
    strokeWidth: 0.403
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeverOffMulti);
export default __webpack_public_path__ + "static/media/arrowLeverOffMulti.88e823b2426b2ebc.svg";
export { ForwardRef as ReactComponent };